import { notify, confirm } from '../../utils/notify';
import React, { useState, useEffect } from 'react';
import Header from '../Header';
import { vendorAPI } from '../../services/api';
import { useListControls, ListToolbar, Pagination } from '../../components/ListControls';
import Topbar from "../../components/Topbar";

const money = n => new Intl.NumberFormat('en-IN',{style:'currency',currency:'INR',maximumFractionDigits:0}).format(Number(n)||0);

function downloadReceipt(p) {
  const html = `<!DOCTYPE html><html><head><meta charset="utf-8"/><title>Payment Receipt - ${p.paymentRequestCode}</title>
<style>*{margin:0;padding:0;box-sizing:border-box;}body{font-family:Arial,sans-serif;background:#f9fafb;display:flex;align-items:center;justify-content:center;min-height:100vh;padding:20px;}
.receipt{background:#fff;border-radius:16px;box-shadow:0 4px 24px rgba(0,0,0,0.1);max-width:480px;width:100%;overflow:hidden;}
.rh{background:linear-gradient(135deg,#1a5276,#1e8449);padding:24px;color:#fff;text-align:center;}
.rh .icon{width:56px;height:56px;background:rgba(255,255,255,0.2);border-radius:50%;margin:0 auto 10px;display:flex;align-items:center;justify-content:center;font-size:24px;}
.rh h2{font-size:18px;margin-bottom:4px;}.rh .sub{font-size:12px;opacity:0.85;}
.badge{display:inline-block;background:rgba(255,255,255,0.25);border-radius:20px;padding:3px 14px;font-size:11px;font-weight:700;margin-top:8px;}
.rb{padding:24px;}.row{display:flex;justify-content:space-between;padding:10px 0;border-bottom:1px solid #f3f4f6;font-size:13px;}
.row:last-child{border-bottom:none;}.rl{color:#6b7280;}.rv{font-weight:600;color:#111827;}
.amt{background:#f0fdf4;border-radius:12px;padding:16px;text-align:center;margin:16px 0;}
.amt .label{font-size:12px;color:#6b7280;margin-bottom:4px;}.amt .value{font-size:24px;font-weight:800;color:#16a34a;}
.rf{background:#f9fafb;padding:10px 24px;text-align:center;font-size:11px;color:#9ca3af;}</style></head>
<body><div class="receipt">
<div class="rh"><div class="icon"><i className="bi bi-tree-fill"></i></div><h2>TSE ENVIRONMENT</h2><div class="sub">Payment Receipt</div><div class="badge">✓ PAYMENT SUCCESSFUL</div></div>
<div class="rb">
<div class="amt"><div class="label">Amount Paid</div><div class="value">${new Intl.NumberFormat('en-IN',{style:'currency',currency:'INR',maximumFractionDigits:0}).format(p.paidAmount||p.requestedAmount)}</div></div>
<div class="row"><span class="rl">Reference</span><span class="rv">${p.paymentRequestCode}</span></div>
<div class="row"><span class="rl">Vendor</span><span class="rv">${p.vendorId?.name||'—'}</span></div>
<div class="row"><span class="rl">Bank</span><span class="rv">${p.vendorId?.bankName||'—'}</span></div>
<div class="row"><span class="rl">Account</span><span class="rv">${p.vendorId?.accountNumber||'—'}</span></div>
<div class="row"><span class="rl">UTR Number</span><span class="rv">${p.utrNumber||'—'}</span></div>
<div class="row"><span class="rl">Payment Date</span><span class="rv">${p.paidAt?new Date(p.paidAt).toLocaleDateString('en-IN'):'—'}</span></div>
<div class="row"><span class="rl">Project</span><span class="rv">${p.projectId?.projectCode||'—'}</span></div>
</div>
<div class="rf">TSE Workspace • Green City, Sector-10, Lucknow - 226010</div>
</div></body></html>`;
  const blob=new Blob([html],{type:'text/html'}); const url=URL.createObjectURL(blob);
  const a=document.createElement('a'); a.href=url; a.download=`Receipt_${p.paymentRequestCode}.html`;
  document.body.appendChild(a); a.click(); document.body.removeChild(a); URL.revokeObjectURL(url);
}

function PaymentReleased() {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  

  useEffect(()=>{
    vendorAPI.listReleased().then(d=>setPayments(d.requests||[])).catch(()=>{}).finally(()=>setLoading(false));
  },[]);

  

  const totalPaid = payments.reduce((s,p)=>s+(p.paidAmount||0),0);
  const lc = useListControls(payments, { searchFields: [p=>p.vendorId?.name, 'paymentRequestCode', 'utrNumber'], dateField: 'paidAt', pageSize: 10 });

  return (
    <>
      <Header/>
      <div id="db-wrapper"><main id="page-content">
          <Topbar section="Vendor Payment" /><section className="container-fluid p-4 pt-3">
        

        <div className="page-hero d-flex align-items-center justify-content-between flex-wrap gap-2">
          <div><h5 className="text-white lh-1">Payment Released</h5><div className="sub">Step 8 — Razorpay payout completed. Bank Transfer, UTR Generated, Real-time Tracking.</div></div>
          <div style={{background:'rgba(255,255,255,0.15)',borderRadius:10,padding:'4px 14px',color:'#fff',fontWeight:600}}>
            <i className="bi bi-currency-rupee me-1"/>{money(totalPaid)} Total Released
          </div>
        </div>

        <div className="row g-2 mb-3">
          {[{l:'Total Released',v:payments.length,bg:'#f0fdf4',ic:'#22c55e',icon:'bi-check-circle'},{l:'Amount Released',v:money(totalPaid),bg:'#eff6ff',ic:'#3b82f6',icon:'bi-currency-rupee',isAmt:true}].map((s,i)=>(
            <div key={i} className="col-6"><div className="kpi-card d-flex align-items-center gap-2"><div className="kpi-icon" style={{background:s.bg}}><i className={`bi ${s.icon}`} style={{color:s.ic}}/></div><div><div style={{fontSize:s.isAmt?'1rem':'1.5rem',fontWeight:700}}>{s.v}</div><div style={{fontSize:'0.7rem',color:'#6b7280'}}>{s.l}</div></div></div></div>
          ))}
        </div>

        {loading?<div className="text-center py-5"><span className="spinner-border text-primary"/></div>
        :payments.length===0?<div className="empty-state"><i className="bi bi-send-check"/><p>No payments released yet</p></div>
        :(<>
        <ListToolbar search={lc.search} setSearch={lc.setSearch} dateFrom={lc.dateFrom} setDateFrom={lc.setDateFrom} dateTo={lc.dateTo} setDateTo={lc.setDateTo} placeholder="Search by vendor, code, UTR..." dateLabel="Paid On"/>
        {lc.paginated.map((p,idx)=>(
          <div key={p._id} className="record-card">
            <div className="record-number">{(lc.page-1)*lc.pageSize+idx+1}.</div>
            <div className="record-body">
              <div className="d-flex align-items-center gap-2 mb-1 flex-wrap">
                <div style={{fontWeight:700,fontSize:'0.874rem',color:'#111827'}}>{p.vendorId?.name||'—'}</div>
                <span className="status-pill status-approved"><i className="bi bi-check-circle"/>Paid</span>
                <span style={{background:'#f0fdf4',color:'#16a34a',fontSize:'0.7rem',fontWeight:700,padding:'2px 7px',borderRadius:20}}>{money(p.paidAmount||p.requestedAmount)}</span>
              </div>
              <div className="row g-2">
                <div className="col-12 col-md-4">
                  <div className="record-field"><span className="rf-label">Reference — </span><span className="rf-value text-primary">{p.paymentRequestCode}</span></div>
                  <div className="record-field"><span className="rf-label">Vendor Code — </span><span className="rf-value">{p.vendorId?.vendorCode}</span></div>
                  <div className="record-field"><span className="rf-label">Project — </span><span className="rf-value">{p.projectId?.projectCode}</span></div>
                </div>
                <div className="col-12 col-md-4">
                  <div className="record-field"><span className="rf-label">Bank — </span><span className="rf-value">{p.vendorId?.bankName||'—'}</span></div>
                  <div className="record-field"><span className="rf-label">Account — </span><span className="rf-value">{p.vendorId?.accountNumber||'—'}</span></div>
                  <div className="record-field"><span className="rf-label">IFSC — </span><span className="rf-value">{p.vendorId?.ifscCode||'—'}</span></div>
                </div>
                <div className="col-12 col-md-4">
                  <div className="record-field"><span className="rf-label">UTR Number — </span><span className="rf-value fw-bold text-success">{p.utrNumber||'—'}</span></div>
                  <div className="record-field"><span className="rf-label">Paid On — </span><span className="rf-value">{p.paidAt?new Date(p.paidAt).toLocaleDateString('en-IN'):'—'}</span></div>
                  <div className="record-field"><span className="rf-label">Razorpay ID — </span><span className="rf-value" style={{fontSize:'0.7rem'}}>{p.razorpayPayoutId||'—'}</span></div>
                </div>
              </div>
            </div>
            <div className="divider d-none d-md-block"/>
            <div className="record-actions">
              <button className="btn-card-download" onClick={()=>downloadReceipt(p)}>Receipt</button>
            </div>
          </div>
        ))}
        <Pagination page={lc.page} totalPages={lc.totalPages} setPage={lc.setPage} totalCount={lc.totalCount} pageSize={lc.pageSize} itemLabel="payments"/>
        </>)}
      </section></main></div>
    </>
  );
}
export default PaymentReleased;
